export function getDefaultUserSituation(lead, postcodeOpen) {
  if (lead.isolatieplanCheck.residentChoosesOwnAdvisor === true) {
    return "selecting_own_advisor";
  } else if (lead.wantsIsolatieplan && lead.isolatieplanCheck.IsolatieplanRequested) {
    return "waiting_isolatieplan";
  } else if (!lead.Isolatieplan_required && lead.isolatieplanCheck.ProceedWithoutPlan) {
    return "quotes_without_plan";
  } else if (!lead.Isolatieplan_required && lead.isolatieplanCheck.Under10kCombined) {
    return "quotes_without_plan";
  } else if (lead.isolatieplanCheck.IsolatieplanRequested) {
    return "waiting_isolatieplan";
  } else if (!postcodeOpen) {
    return "waiting_postcode";
  } else {
    return "appointment_isolatieplan";
  }
}

export function getFilteredSituationOptions(lead, postcodeOpen, situationOptions) {
  return situationOptions.filter((opt) => {
    if (opt.value === "appointment_isolatieplan") {
      if (lead.wantsIsolatieplan && lead.isolatieplanCheck.IsolatieplanRequested) {
        return false;
      } else if (lead.Isolatieplan_required && lead.isolatieplanCheck.IsolatieplanRequested) {
        return false;
      } else if (lead.isolatieplanCheck.IsolatieplanRequested) {
        return false;
      } else if (lead.isolatieplanCheck.residentChoosesOwnAdvisor) {
        return false;
      }
      // else if (lead.isolatieplanCheck.ProceedWithoutPlan === true) {
      //   return false;
      // } else if (lead.isolatieplanCheck.Under10kCombined === true) {
      //     return false;
      // }
    }

    if (opt.value === "waiting_postcode") {
      if (postcodeOpen) {
        return false;
      } else if (lead.wantsIsolatieplan && lead.isolatieplanCheck.IsolatieplanRequested) {
        return false;
      } else if (lead.Isolatieplan_required && lead.isolatieplanCheck.IsolatieplanRequested) {
        return false;
      } else if (lead.isolatieplanCheck.residentChoosesOwnAdvisor) {
        return false;
      }
      // else if (lead.isolatieplanCheck.ProceedWithoutPlan === true) {
      //   return false;
      // } else if (lead.isolatieplanCheck.Under10kCombined === true) {
      //   return false;
      // } 
    }

    if (opt.value === "waiting_isolatieplan") {
      if (lead.wantsIsolatieplan === false) {
        return false;
      } else if (!lead.Isolatieplan_required && lead.isolatieplanCheck.ProceedWithoutPlan === true) {
        return false;
      } else if (!lead.Isolatieplan_required && lead.isolatieplanCheck.Under10kCombined === true) {
        return false;
      } else if (lead.isolatieplanCheck.IsolatieplanRequested === false && lead.isolatieplanCheck.residentChoosesOwnAdvisor === false) {
        return false;
      } else if (lead.isolatieplanCheck.residentChoosesOwnAdvisor === true) {
        return false;
      } else if (lead.isolatieplanCheck.IsolatieplanReceived === true) {
        return false;
      }
    }

    if (opt.value === "quotes_without_plan") {
        if (lead.wantsIsolatieplan && lead.isolatieplanCheck.IsolatieplanRequested) {
            return false;
        } else if (lead.Isolatieplan_required) {
            return false;
        } 
      //   else if (lead.isolatieplanCheck.IsolatieplanRequested === false) {
      //       return false;
      // }
    }

    if (opt.value === "help_retroactive") {
      if (!lead.address.m29_ontzorging_door_BvV_toegestaan) {
        return false;
      } else if (lead.twk.IntakeMeasuresExecuted === false) {
        return false;
      }
    }

    if (opt.value === "general_info") {
      if (!lead.address.m29_ontzorging_door_BvV_toegestaan) {
        return false;
      }
    }

    if (opt.value === "help_execution") {
      if (lead.isolatieplanCheck.IsolatieplanReceived === false || lead.isolatieplanCheck.IsolatieplanReceived === null) {
        return false;
      }
    }

    if (opt.value === "help_financing") {

       if (!lead.address.m29_ontzorging_door_BvV_toegestaan) {
        return false;
       }
      
      if (!lead.financing.wantHelpFinancing) {
        return false;
       }
    }

    if (opt.value === "help_finishing") {
      if (!lead.address.m29_ontzorging_door_BvV_toegestaan) {
        return false;
      }
      
      if (lead.isolatieplanCheck.IsolatieplanReceived !== true && lead.isolatieplanCheck.IsolatieplanRequested === true) {
        return false;
      } else if (!lead.Isolatieplan_required && lead.isolatieplanCheck.ProceedWithoutPlan) {
        return false;
      }
    }

    if (opt.value === 'selecting_own_advisor') {
      if (lead.isolatieplanCheck.residentChoosesOwnAdvisor === false || lead.isolatieplanCheck.residentChoosesOwnAdvisor === null) {
        return false;
      }
    }

    return true;
  });
}
